import { QueryString } from 'core/utils/queryString/queryString';
import { getWindowLocation } from 'core/window/windowService';

const MAX_INT32 = Math.pow(2, 31) - 1;

export const copyTextToClipboard = (textToCopy: string, doc = document, windowArg = window): void => {
    const listener = (e: ClipboardEvent) => {
        const clipboard = e.clipboardData || (windowArg as unknown as ClipboardEvent).clipboardData;
        if (clipboard) {
            clipboard.setData('text', textToCopy);
        }
        if (e.preventDefault) e.preventDefault();
    };

    doc.addEventListener('copy', listener, false);
    doc.execCommand('copy');
    doc.removeEventListener('copy', listener, false);
};

export const parseQueryString = (location = getWindowLocation()): Record<string, string> => {
    const parsed = QueryString.parseQueryString(location.search || location.hash.replace(/#.+[?]/, ''));
    return Object.keys(parsed).length > 0 ? parsed : {};
};

export const getForcedUserVariant = (location = getWindowLocation()) => {
    const qs = parseQueryString(location);
    return qs.expuser || '';
};

/* eslint-disable no-bitwise */
export const guid = (): string => {
    const randomNumbers = new Uint8Array(40);
    crypto.getRandomValues(randomNumbers);

    let index = 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = randomNumbers[index] & 15;
        index += 1;
        // eslint-disable-next-line no-mixed-operators
        const v: number = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};

export const getElementAtIndex = <T>(array: T[] | undefined, index: number): T | undefined => {
    if (array === undefined || array === null) {
        return undefined;
    }
    // ToInteger() abstract op
    let n = Math.trunc(index) || 0;
    // Allow negative indexing from the end
    if (n < 0) n += array.length;
    // OOB access is guaranteed to return undefined
    if (n < 0 || n >= array.length) return undefined;
    // Otherwise, this is just normal property access
    return array[n];
};

export const isInPositiveInt32Range = (value: number): boolean => {
    return value <= MAX_INT32 && value > 0;
};
